import React, { useCallback, useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
interface Testimonial {
  quote: string;
  initial: string;
  name: string;
  location: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Llevaba meses sin ver progreso. Empecé con la Whey Protein CIBELES y en 6 semanas ya notaba la diferencia en el espejo. Y el precio con el 20% me pareció increíble.',
  initial: 'M',
  name: 'Matías R.',
  location: 'Cliente — Montevideo'
}, {
  quote: 'La Creatina CREAPURE es de otra categoría. Me recupero mucho más rápido entre sesiones y levanto más peso en cada entrenamiento. El envío llegó rapidísimo.',
  initial: 'S',
  name: 'Sofía L.',
  location: 'Cliente — Pocitos'
}, {
  quote: 'Siempre compré importado y pagaba el doble. Probé AlphaFit por recomendación y no vuelvo atrás. Calidad igual o mejor, precio imposible de superar.',
  initial: 'F',
  name: 'Federico G.',
  location: 'Cliente — Punta Carretas'
}, {
  quote: 'Pedí por WhatsApp a las 11 de la mañana y a las 4 de la tarde ya lo tenía en casa. Súper práctico y el asesoramiento fue muy bueno, me ayudaron a elegir lo que necesitaba.',
  initial: 'L',
  name: 'Lucía M.',
  location: 'Cliente — Malvín'
}, {
  quote: 'Empecé con el Anabolic Mass de Profit y noté un cambio real en mi volumen muscular. Me costaba mucho subir de peso y con este gainer por fin estoy viendo resultados semana a semana.',
  initial: 'D',
  name: 'Diego P.',
  location: 'Cliente — Buceo'
}, {
  quote: 'Lo que más valoro es la honestidad. Me recomendaron el suplemento justo para mi objetivo en vez de venderme el más caro. Eso genera confianza y por eso sigo comprando acá.',
  initial: 'V',
  name: 'Valentina S.',
  location: 'Cliente — Cordón'
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  // How many cards visible at once
  const getVisibleCount = () => {
    if (typeof window === 'undefined') return 3;
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  };
  const [visibleCount, setVisibleCount] = useState(getVisibleCount());
  useEffect(() => {
    const handleResize = () => setVisibleCount(getVisibleCount());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const maxIndex = testimonials.length - visibleCount;
  const goNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [maxIndex, isTransitioning]);
  const goPrev = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex(prev => prev <= 0 ? maxIndex : prev - 1);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [maxIndex, isTransitioning]);
  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(goNext, 5000);
    return () => clearInterval(interval);
  }, [goNext]);
  return <section className="bg-dark-900 py-[80px] px-5" data-id="element-425" data-mp="1b8kcvc36pv0k">
      <div className="max-w-[1100px] mx-auto" data-id="element-426" data-mp="16862hne428zd">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-427" data-mp="169h5hkzqfcpf">
          Lo Que Dicen Nuestros Clientes
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-428" data-mp="wgigw348jm5t">
          Resultados reales de personas reales en Uruguay
        </p>

        <div className="relative" data-id="element-429" data-mp="sdlu007nx3w2">
          {/* Navigation arrows */}
          <button onClick={goPrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 md:-translate-x-5 z-10 bg-dark-600 border border-dark-300 rounded-full w-10 h-10 flex items-center justify-center text-white transition-all duration-300 hover:border-alphaGold hover:text-alphaGold" aria-label="Previous testimonial" data-id="element-430" data-mp="nig9n5twrxa3">
            <ChevronLeft className="w-5 h-5" data-id="element-431" data-mp="2ij07tblsri3w" />
          </button>
          <button onClick={goNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 md:translate-x-5 z-10 bg-dark-600 border border-dark-300 rounded-full w-10 h-10 flex items-center justify-center text-white transition-all duration-300 hover:border-alphaGold hover:text-alphaGold" aria-label="Next testimonial" data-id="element-432" data-mp="23vf4bgl0fgvg">
            <ChevronRight className="w-5 h-5" data-id="element-433" data-mp="1zr7eth6q9ww6" />
          </button>

          {/* Carousel container */}
          <div className="overflow-hidden mx-6 md:mx-8" data-id="element-434" data-mp="1kynqhmo8ltys">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`
          }} data-id="element-435" data-mp="1pw5q2mgd6wu4">
              {testimonials.map((t, i) => <div key={i} className="flex-shrink-0 px-2" style={{
              width: `${100 / visibleCount}%`
            }} data-id="element-436" data-mp="18laa5a6gtn8n" data-mpi={i}>
                  <div className="bg-dark-600 border border-dark-400 rounded-lg p-[30px] h-full flex flex-col" data-id="element-437" data-mp="1icn17zkfw9dm">
                    <div className="flex text-alphaGold mb-3 gap-1" data-id="element-438" data-mp="1djk6ho3xetvu">
                      <Star className="w-4 h-4 fill-current" data-id="element-439" data-mp="1rbrxt0cfxsn5" />
                      <Star className="w-4 h-4 fill-current" data-id="element-440" data-mp="1nayao96tohvb" />
                      <Star className="w-4 h-4 fill-current" data-id="element-441" data-mp="1naeq0kpsffdl" />
                      <Star className="w-4 h-4 fill-current" data-id="element-442" data-mp="21b8yt4gqzics" />
                      <Star className="w-4 h-4 fill-current" data-id="element-443" data-mp="218d55sbxnfu5" />
                    </div>
                    <p className="text-[#bbb] text-[0.92rem] leading-[1.7] mb-[18px] italic flex-1" data-id="element-444" data-mp="1w9jo5pxft6p8">
                      "{t.quote}"
                    </p>
                    <div className="flex items-center gap-3" data-id="element-445" data-mp="1yn40wczaxu2">
                      <div className="w-[42px] h-[42px] rounded-full bg-alphaGold flex items-center justify-center font-black text-[1rem] text-white flex-shrink-0" data-id="element-446" data-mp="21zus1khd0tgi">
                        {t.initial}
                      </div>
                      <div data-id="element-447" data-mp="2b09n3bk4lmx7">
                        <div className="font-bold text-white text-[0.9rem]" data-id="element-448" data-mp="2ayzpsol3kirm">
                          {t.name}
                        </div>
                        <div className="text-[#666] text-[0.8rem]" data-id="element-449" data-mp="2kyqmmwx4r9uv">
                          {t.location}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Dots indicator */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-450" data-mp="2yqn5sbgtm9f4">
            {Array.from({
            length: maxIndex + 1
          }).map((_, i) => <button key={i} onClick={() => {
            setCurrentIndex(i);
          }} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 border-none cursor-pointer ${i === currentIndex ? 'bg-alphaGold w-6' : 'bg-dark-400 hover:bg-dark-300'}`} aria-label={`Go to slide ${i + 1}`} data-id="element-451" data-mp="33n3vha3o4vub" data-mpi={i} />)}
          </div>
        </div>
      </div>
    </section>;
}